import zipImg from '../assets/media/zip.png'
import docImg from '../assets/media/word.png'
import xlsxImg from '../assets/media/xlsx.png'
import pdfImg from '../assets/media/pdf.png'
import playImg from '../assets/media/play.png'
import txtImg from '../assets/media/txt.png'

// 文件相关的常量

export const allFileType = [
  {
    name: '图片',
    key: 'image',
    suffix: ['.gif', '.png', '.jpg', '.jpeg', '.bmp', '.webp'],
    extension: [
      'gif',
      'png',
      'jpg',
      'jpeg',
      'bmp',
      'webp',
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/gif',
      'image/bmp',
    ],
  },
  {
    name: '视频',
    key: 'video',
    suffix: [
      '.mp4',
      '.m3u8',
      '.flv',
      '.f4v',
      '.webm',
      '.m4v',
      '.mov',
      '.3gp',
      '.avi',
      '.wmv',
    ],
    extension: [
      'mp4',
      'm3u8',
      'flv',
      'f4v',
      'webm',
      'm4v',
      'mov',
      '3gp',
      'avi',
      'wmv',
    ],
  },
  {
    name: '音频',
    key: 'audio',
    suffix: ['.mp3', '.wma', '.wav', '.amr', '.m4a'],
    extension: ['mp3', 'wma', 'wav', 'amr', 'm4a'],
  },
  {
    name: '文档',
    key: 'doc',
    suffix: ['.doc', '.docx', '.pdf', '.ppt', '.pptx', '.txt'],
    extension: ['doc', 'docx', 'ppt', 'pptx'],
  },
  {
    name: 'excl',
    key: 'xls',
    suffix: ['.xls', '.xlsx'],
    extension: ['xls', 'xlsx'],
  },
  {
    name: 'txt文档',
    key: 'txt',
    suffix: ['.txt'],
    extension: ['txt'],
  },
  {
    name: 'pdf文档',
    key: 'pdf',
    suffix: ['.pdf'],
    extension: ['pdf'],
  },
  {
    name: '压缩文件',
    key: 'zip',
    suffix: ['.rar', '.zip', '.gzip'],
    extension: ['rar', 'zip', 'gzip'],
  },
]
// 用于显示文件 缩略图
export const fileTypeImg = {
  gif: docImg,
  png: docImg,
  jpg: docImg,
  jpeg: docImg,
  bmp: docImg,
  video: playImg,
  mp4: playImg,
  m3u8: playImg,
  flv: playImg,
  f4v: playImg,
  webm: playImg,
  mov: playImg,
  '3gp': playImg,
  avi: playImg,
  wmv: playImg,
  mp3: playImg,
  wma: playImg,
  wav: playImg,
  amr: playImg,
  m4a: playImg,
  doc: docImg,
  docx: docImg,
  pdf: pdfImg,
  xls: xlsxImg,
  xlsx: xlsxImg,
  ppt: pdfImg,
  pptx: docImg,
  txt: txtImg,
  rar: zipImg,
  zip: zipImg,
  gzip: zipImg,
}
// 图、音、视频格式
export const imgAudioVideo = [
  '.gif',
  '.png',
  '.jpg',
  '.jpeg',
  '.bmp',
  '.mp4',
  '.m3u8',
  '.flv',
  '.f4v',
  '.webm',
  '.m4v',
  '.mov',
  '.3gp',
  '.avi',
  '.wmv',
  '.mp3',
  '.wma',
  '.wav',
  '.amr',
  '.m4a',
]
